module.exports = __webpack_public_path__ + "static/media/streak-1.909446af.png";